import React, { useState, useEffect } from 'react';
import { message } from 'antd';
import supplyChainService, { Shop } from '../../services/supplyChainService';
import StoreTable from './components/StoreTable';
import StoreForm from './components/StoreForm';

const StoreManagement: React.FC = () => {
    // Mode: 'list' | 'edit' | 'create'
    const [mode, setMode] = useState<'list' | 'edit' | 'create'>('list');

    // List State
    const [shops, setShops] = useState<Shop[]>([]);
    const [loading, setLoading] = useState(false);

    // Edit State
    const [editingShop, setEditingShop] = useState<Shop | null>(null);

    const fetchShops = async () => {
        setLoading(true);
        try {
            const res = await supplyChainService.getShops();
            const data = res.data as any;
            setShops(Array.isArray(data) ? data : data?.results || []);
        } catch (error) {
            message.error('加载店铺失败');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchShops();
    }, []);

    const handleAdd = () => {
        setEditingShop(null);
        setMode('create');
    };

    const handleEdit = (record: Shop) => {
        setEditingShop(record);
        setMode('edit');
    };

    const handleDelete = async (id: number) => {
        try {
            await supplyChainService.deleteShop(id);
            message.success('店铺已删除');
            fetchShops();
        } catch (error) {
            message.error('删除店铺失败');
        }
    };

    const handleSave = async (values: any) => {
        try {
            if (mode === 'edit' && editingShop?.id) {
                await supplyChainService.updateShop(editingShop.id, values);
                message.success('店铺已更新');
            } else {
                await supplyChainService.createShop(values);
                message.success('店铺已创建');
            }
            setMode('list');
            fetchShops();
        } catch (error) {
            message.error('请检查表单填写是否正确');
            throw error; // Let form handle error if needed
        }
    };

    const cancelEdit = () => {
        setMode('list');
        setEditingShop(null);
    };

    if (mode === 'list') {
        return (
            <StoreTable
                shops={shops}
                loading={loading}
                onAdd={handleAdd}
                onEdit={handleEdit}
                onDelete={handleDelete}
            />
        );
    }

    return (
        <StoreForm
            mode={mode as 'create' | 'edit'}
            initialValues={editingShop}
            onSave={handleSave}
            onCancel={cancelEdit}
        />
    );
};

export default StoreManagement;
